import { render, staticRenderFns } from "./ContextPlugin.vue?vue&type=template&id=56e37766&scoped=true"
import script from "./ContextPlugin.vue?vue&type=script&lang=js"
export * from "./ContextPlugin.vue?vue&type=script&lang=js"
import style0 from "./ContextPlugin.vue?vue&type=style&index=0&id=56e37766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e37766",
  null
  
)

export default component.exports